import React from "react"

interface ISectionProps {
    title: string | JSX.Element
    icon?: JSX.Element
    sectionKey: string
    children: React.ReactNode
}

export interface ISectionWithRef extends ISectionProps {
    sectionRef: React.RefObject<HTMLDivElement>
}

export const Section: React.FC<ISectionProps> = () => {
    return null
}

export const SectionWithRef: React.FC<ISectionWithRef> = () => {
    return null
}
